import Vue from "vue";
import * as ENDPOINTS from "./endpoints";
import { resolveRequestError } from "@/utils/auth";

export default class TeamService {

    // ============ CREAT TEAM  =============
    static async createTeam({ name, permissions}){
        try{
            const { data } = await Vue.http.post(ENDPOINTS.TEAM, {
                name,
                permissions
            });
            return data;
        }
        catch(error){
            resolveRequestError(error)
        }
    }

    // ============== GET ALL TEAMS =============
    static async getTeams(){
        try {
            const { data } = await Vue.http.get(ENDPOINTS.TEAM);
            return data;
        } catch (error) {
            resolveRequestError(error)
        }
    }

    // ============ GET A PARTICULAR TEAM BY ID ================
    static async getTeam( { id } ){
        try {
            const { data } = await Vue.http.get(ENDPOINTS.TEAM + `/${id}`);
            return data;
        } catch (error) {
            resolveRequestError(error);
        }
    }

    // =============== ADD ADMIN TO TEAM ================
    static async addToTeam( { admin, department } ){
        try {
            const { data } = await Vue.http.post(ENDPOINTS.TEAM + '/teams', {
                admin,
                department
            });
            console.log(data);
        } catch (error) {
            resolveRequestError(error)
        }
    }

     // =============== REMOVE ADMIN TO TEAM ================
     static async removeFromTeam( { admin, department } ){
        try {
            const { data } = await Vue.http.patch(ENDPOINTS.TEAM + '/teams', {
                admin,
                department
            });
            console.log(data);
        } catch (error) {
            resolveRequestError(error)
        }
    }


}